import React from "react";
import { TextField, TextFieldProps, Box } from "@mui/material";
import { styled } from "@mui/material/styles"; 
import { StyledInputLabel } from "../modules/fiscalUpgrade/StyledComponents/Container";

interface CustomTextFieldProps extends Omit<TextFieldProps, 'readOnly'> {
  readOnly?: boolean;
  error?: boolean;
  helperText?: string;
  labelText?: string; // for the custom label
  required?: boolean;
  width?: string | number;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
}

const InputForTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'readOnly',
})<{ readOnly?: boolean; error?: boolean }>(({ theme, readOnly, error }) => ({
  "label + &": {
    marginBottom: theme.spacing(2),
  },
  "& .MuiInputBase-input": {
    borderRadius: "5px",
    backgroundColor: readOnly ? "#F5F5F5" : "#FFFFFF",
    fontSize: "17.67px",
    fontWeight: 400,
    color: readOnly ? "#9E9E9E" : "#2C2222",
    letterSpacing: "0.27px",
    height: "23.5px", 
    fontFamily: ["Inter", "sans-serif"],
  },
  "& .MuiFormHelperText-root": {
    color: error ? "#d42f2f" : theme.palette.text.secondary,
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: error ? "#d42f2f" : theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: error && "#d42f2f",
    },
  },
}));

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  labelText,
  required = false,
  error,
  helperText,
  readOnly = false,
  size = "small",
  onBlur,
  variant = "outlined", 
  ...props
}) => {
  return (
    <Box  >
      {labelText && (
        <StyledInputLabel shrink>
          {labelText} {required && <span style={{ color: "red" }}>*</span>}
        </StyledInputLabel>
      )}
      <InputForTextField
        {...props}
        fullWidth
        size={size}
        variant={variant}
        error={error}
        helperText={helperText}
        readOnly={readOnly}
        disabled={readOnly}
        onBlur={onBlur} 
      />
    </Box>
  );
};

export default CustomTextField;
